<script setup lang="ts">
    import type { CheckboxRootEmits, CheckboxRootProps } from 'reka-ui';
    import { cn } from '@/lib/utils';
    import { Check, Minus } from 'lucide-vue-next';
    import { CheckboxIndicator, CheckboxRoot, useForwardPropsEmits } from 'reka-ui';
    import { computed, type HTMLAttributes } from 'vue';

    const props = defineProps<CheckboxRootProps & { class?: HTMLAttributes['class'] }>();
    const emits = defineEmits<CheckboxRootEmits>();

    const delegatedProps = computed(() => {
        const { class: _, ...delegated } = props;
        return delegated;
    });

    const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
    <CheckboxRoot
        data-slot="checkbox"
        v-bind="forwarded"
        :class="
            cn(
                'peer border-input data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground data-[state=checked]:border-primary data-[state=indeterminate]:border-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 cursor-pointer rounded-[4px] border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
                props.class,
            )
        "
    >
        <CheckboxIndicator
            data-slot="checkbox-indicator"
            class="flex items-center justify-center text-current transition-none"
        >
            <slot :state="forwarded.modelValue">
                <Minus
                    v-if="forwarded.modelValue === 'indeterminate'"
                    class="size-3.5"
                />
                <Check
                    v-else
                    class="size-3.5"
                />
            </slot>
        </CheckboxIndicator>
    </CheckboxRoot>
</template>
